import { render } from "./survey_add_prize.vue?vue&type=template&id=00d5365d&scoped=true"
import script from "./survey_add_prize.vue?vue&type=script&lang=js"
export * from "./survey_add_prize.vue?vue&type=script&lang=js"

import "./survey_add_prize.vue?vue&type=style&index=0&id=00d5365d&lang=css"
import "./survey_add_prize.vue?vue&type=style&index=1&id=00d5365d&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00d5365d"]])

export default __exports__